import React, {
  createContext,
  useState,
  useEffect,
  useMemo,
  useContext,
} from 'react';
import { AuthContext } from './AuthContext';
import { getUserRef } from '../firebase/collections';

const STORAGE_KEY = 'sebusca_browse_location';

export const LocationContext = createContext(null);

function getStored() {
  try {
    const s = localStorage.getItem(STORAGE_KEY);
    if (s) {
      const parsed = JSON.parse(s);
      if (parsed && (parsed.city || parsed.state)) return parsed;
    }
  } catch (e) {}
  return { city: '', state: '' };
}

function saveStored(loc) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(loc || {}));
  } catch (e) {}
}

function ContextLocation({ children }) {
  const { user } = useContext(AuthContext) || {};
  const [location, setLocation] = useState(getStored);

  useEffect(() => {
    saveStored(location);
  }, [location]);

  // If local storage has no location, fall back to user's saved profile location
  useEffect(() => {
    if (!location.state && !location.city && user?.uid) {
      getUserRef(user.uid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const data = doc.data();
            const userLoc = data.location || {};
            if (userLoc.state || userLoc.city) {
              setLocation({
                state: userLoc.state || '',
                city: userLoc.city || '',
              });
            }
          }
        })
        .catch(() => {});
    }
  }, [user?.uid]); // eslint-disable-line react-hooks/exhaustive-deps

  const value = useMemo(
    () => ({ browseLocation: location, setBrowseLocation: setLocation }),
    [location]
  );

  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
}

export default ContextLocation;
